<mat-list-item (click)='redirectTo("/manage/looker/" + meta.client_route)' [routerLink]='"/manage/looker/" + meta.client_route'
               [ngClass]="{'selected': setActiveNav('/manage/looker/' + meta.client_route)}"
>
  <a class="relative" matRipple>
    <span>{{meta.friendly_name}}</span>
  </a>
</mat-list-item>
